module.exports = __webpack_public_path__ + "media/images/logo/orangeclicks-old-5c698d876e637a34c8c9283b5ee82c06.png";